import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import TextInput, {
  TextInputProps,
} from 'up-ops-web-shared-components/lib/components/inputs/text-input';

import { FormComponentProps } from 'types/components';

type FormTextInputProps = TextInputProps & FormComponentProps;

const FormTextInput = ({
  defaultValue = '',
  name,
  rules,
  ...props
}: FormTextInputProps) => {
  const { control, formState } = useFormContext();
  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      name={name}
      render={({ field, fieldState }) => {
        const { onBlur, onChange, ref, value } = field;
        const { error, invalid } = fieldState;
        return (
          <TextInput
            disabled={formState.isSubmitting}
            error={invalid}
            hint={error?.message}
            innerRef={ref}
            name={name}
            onBlur={onBlur}
            onChange={onChange}
            value={value}
            {...props}
          />
        );
      }}
      rules={rules}
    />
  );
};

export default FormTextInput;
